import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import Api from "lib/api/httpRequestHelper";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import InputText from "components/_refactor/text/input";

const TIPO_RETORNO = [
  { name: "Com retorno", value: "COM_RETORNO" },
  { name: "Sem retorno", value: "SEM_RETORNO" },
];

export default function ConfirmDialog({
  type,
  onClose,
  idSolicitacao,
  handleSearch,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [tipoRetorno, setTipoRetorno] = useState("");
  const [justificativa, setJustificativa] = useState("");

  const isApprove = type === "accept";
  const isReject = type === "reject";
  const isApproveDoc = type === "acceptDoc";
  const isRejectDoc = type === "rejectDoc";

  const snackbar = useSnackbar();

  const submit = async () => {
    setSubmitting(true);
    const endpoint =
      isApprove || isApproveDoc
        ? "approve-request"
        : isReject
        ? "reject-request"
        : "notification-document";

    const body = {
      idSolicitacao: idSolicitacao,
      ...(!isRejectDoc && {
        statusSolicitacao: isApprove
          ? "AG_ENVIO_NOTA"
          : isReject
          ? "REPROVADO"
          : isApproveDoc
          ? "DOC_APROVADOS"
          : "",
      }),
      ...(isRejectDoc && { motivoReprovacao: justificativa }),
      ...(isReject && { justificativa: justificativa }),
      ...(isApprove && { tipoRetorno: tipoRetorno.value }),
    };

    try {
      const response = await Api.put(endpoint, "returnRequest", body, true);
      if (response.Success) {
        snackbar.showMessage(
          isApprove || isApproveDoc
            ? "Solicitação aprovada com sucesso!"
            : "Solicitação rejeitada com sucesso!",
          {
            severity: "success",
          }
        );
        onClose();
        handleSearch();
      }
    } catch (error) {
      snackbar.showMessage(
        isApprove || isApproveDoc
          ? "Erro ao aprovar solicitação: " + error.message
          : "Erro ao rejeitar solicitação: " + error.message,
        {
          severity: "error",
        }
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth={"md"}>
      <DialogTitle>
        <Typography variant="h3">
          {isApprove || isApproveDoc
            ? "Aprovar Solicitação"
            : "Recusar Solicitação"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h4" style={{ marginBottom: "1rem" }}>
          Tem certeza que deseja{" "}
          {isApprove || isApproveDoc ? "aprovar" : "recusar"} essa solicitação
          {isApprove && " para envio dos documentos"}?
        </Typography>
        {isApprove && (
          <AutoCompleteField
            label="Tipo de Aprovação"
            onChange={(value) => {
              setTipoRetorno(value);
            }}
            value={tipoRetorno}
            options={TIPO_RETORNO}
            optionLabelKey="name"
            optionIdKey="value"
          />
        )}
        {(isReject || isRejectDoc) && (
          <Box>
            <Typography variant="h5" style={{ marginBottom: "0.5rem" }}>
              Justificativa:
            </Typography>
            <Box position="relative">
              <InputText
                multiline
                rows={4}
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                placeholder="Digite a justificativa para a recusa da solicitação"
                disabled={submitting}
                inputProps={{ maxLength: 1000 }}
              />
              <Typography
                variant="caption"
                color="textPrimary"
                style={{
                  position: "absolute",
                  right: 0,
                  bottom: 10,
                  marginRight: "0.5rem",
                  marginBottom: "0.5rem",
                  fontSize: "0.75rem",
                }}
              >
                {justificativa.length}/1000
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={submitting || ((isReject || isRejectDoc) && !justificativa)}
          onClick={submit}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
